import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { StoreService } from '../../services/store.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { MainDataService } from '../../services/main-data.service';
import { Language } from 'src/app/interfaces/language.model';
import { LanguageService } from '../../services/language.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthTokenService } from '../../services/token.service';

import { CartService } from "../../services/cart.service";
import { LoaderService } from "../../services/loader.service";
import { TenantService } from "../../../pages/landing/services/tenant.service";
import { AppDataService } from "../../services/app-data.service";
import UtilityFunctions from "../../../utilities/functions";
import { AuthService } from "../../services/auth.service";

declare let google: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('op', { static: false }) op: any;
  isShowYello: boolean = environment.isStoreCloud
  subscription: Array<Subscription> = [];
  isActiveSearch: boolean = false;
  isfirstTime: boolean = false;
  products: Array<any> = [];
  authToken: any = '';
  logo: string = '/Images/logo.png';
  user: any;
  Name: string = '';
  baseUrl: string;
  languages: Array<Language> = new Array<Language>();
  search: string = '';
  selectedTenant: any;
  Lat!: number;
  Lng!: number;
  zoom!: number;
  address!: string;
  deliverTo!: any;
  countries: Array<any> = [];
  myplaceHolder: string | undefined;
  source: any;
  permission: any;
  isShop: boolean = false;
  selectedLanguage: any;
  screenWidth?: any;
  count: any;
  innerWidth?: number;
  mobileScreen: boolean = false;
  scConf: boolean = false;
  desktopView: boolean = true;
  showDialog: boolean = false;
  merchantURL: any = environment.merchantURL
  countriesList: any;
  allCountries: any = [];
  cartListCount: any = 0;
  cartListData: any = [];
  public country: string = '';
  private geoCoder: any;
  private _BaseURL = environment.apiEndPoint;
  defaultLanguage: Language;
  yallaHeaderLogo: string = 'assets/icons/white-logo.svg';

  constructor(
    private ngZone: NgZone,
    private store: StoreService,
    private router: Router,
    private languageService: LanguageService,
    private translate: TranslateService,
    private mainDataService: MainDataService,
    private cd: ChangeDetectorRef,
    private cartService: CartService,
    private authTokenService: AuthTokenService,
    private messageService: MessageService,
    private cookieService: CookieService,
    private loaderService: LoaderService,
    private tenantService: TenantService,
    private appDataService: AppDataService,
    private authService: AuthService
  ) {
    this.baseUrl = `${environment.apiEndPoint}`;
    this.screenWidth = window.screen.width;
    if (this.screenWidth > 768) {
      this.desktopView = true;
    } else {
      this.desktopView = false;
    }
    if (environment.isStoreCloud) {
      this.scConf = true;
      if (!authService.isMarketplace()) {
        const initialData = this.appDataService.initialData
        if (initialData.result && initialData.result.records) {
          initialData.result.records.forEach((x: any) => {
            if (x.key === 'Logo') {
              this.yallaHeaderLogo = UtilityFunctions.verifyImageURL(x.displayName, this._BaseURL)
            }
          })
        }
      }
    } else {
      this.scConf = false;
    }
  }

  ngOnInit(): void {

    this.innerWidth = window.innerWidth;

    this.selectedLanguage = localStorage.getItem('lang') ? localStorage.getItem('lang') : this.defaultLanguage;
    this.mainDataService.getCartLengthData().subscribe((data: any) => {

      this.cartListCount = data ?? 0;
      if (this.cartListCount > 0) {

        if (this.cartListCount > 9) {
          this.cartListCount = '9+';
        }
      }
      this.cd.markForCheck();
      this.cd.detectChanges();
    });
    this.mainDataService.getUserData().subscribe((data: any) => {
      if (data) {
        let firstName = data.name.split(' ')[0];
        this.Name = firstName;
      }
      this.cd.markForCheck();
      this.cd.detectChanges();
    });
    let user: any = this.store.get('profile');


    if (user) {
      this.mainDataService.setUserData(user)
    }
    if (this.innerWidth < 768) {
      this.mobileScreen = true;
    } else {
      this.mobileScreen = false;
    }
    this.getLanguages();
    this.getAllCountries();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.authToken) {
      const ele: any = document.getElementById('profile');
      ele.click();
      this.op.hide();
    }
  }

  // searchCountries(event: any) {
  //   if (this.country.length >= 1) {
  //     this.countriesList = this.allCountries.filter((item: any) => item.name.toLowerCase().includes(this.country.toLowerCase()))
  //   } else if (this.country.length === 0) {
  //     this.countriesList = this.allCountries
  //   }
  // }
  searchCountries(event: any) {
    if (this.country.length >= 1) {
      const normalizedCountry = this.removeDiacritics(this.country.toLowerCase());
      this.countriesList = this.allCountries.filter((item: any) =>
        this.removeDiacritics(item.name.toLowerCase()).includes(normalizedCountry)
      );
    } else if (this.country.length === 0) {
      this.countriesList = this.allCountries;
    }
  }

  removeDiacritics(text: any) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  countryFlagImages(img: any) {
    return UtilityFunctions.verifyImageURL(img, this._BaseURL);

  }
  onCountrySelected(callingCode: any) {
    if (callingCode == '233') {
      return '2';
    } else if (callingCode == '+256') {
      return '1';
    } else if (callingCode == '225') {
      return '4';
    } else if (callingCode == '20') {
      return '3';
    }
    return '';
  }

  getMainData(): void {
    const initialData = this.appDataService.initialData
    this.isShop = initialData.isShop;
    this.store.set('isShop', this.isShop);
  }

  async SetTenant() {
    this.authToken = null;
    localStorage.clear();
    await this.logOut();
    localStorage.setItem('tenantId', this.selectedTenant);
    localStorage.setItem('allCountryTenants', JSON.stringify(this.countries));
    localStorage.Set('appData_cache','');
    this.store.set('cartProducts', []);
    localStorage.setItem('sessionId', '');
    this.store.set('SessionId', '');
    this.Name = '';
    this.resetStorage();
  }

  // getAllCountries() {
  //   const tenants = this.appDataService.tenants
  //   if (tenants.records) {
  //     const countries = tenants.records;
  //     console.log('countries',countries);
  //
  //     countries[0].selected = true;
  //     const tenantId = localStorage.getItem('tenantId');
  //     if (tenantId && tenantId !== '') {
  //       this.selectedTenant = countries.find((country: any) => country.tenantId == tenantId)
  //     }
  //     this.countries = countries;
  //     this.countriesList = this.countries;
  //     this.allCountries = this.countriesList;
  //   }
  // }

  getAllCountries() {
    const tenants = this.appDataService.tenants
    if (tenants.records) {
      // Temporarily only Egypt is available in the country picker
      const countries = tenants.records.filter(
        (country: any) => country.isoCode?.toUpperCase() === 'EG'
      );

      if (countries.length) {
        countries[0].selected = true;
      }
      const tenantId = localStorage.getItem('tenantId');
      if (tenantId && tenantId !== '') {
        this.selectedTenant = countries.find((country: any) => country.tenantId == tenantId)
          ?? countries[0];
      } else {
        this.selectedTenant = countries[0];
      }
      this.countries = countries;
      this.countriesList = this.countries;
      this.allCountries = this.countriesList;
    }
  }

  setupCountry() {
    let tenantId = localStorage.getItem('tenantId');
    this.isShop = localStorage.getItem('ShopId') != null;
    let permission = 'not-granted';
    if (window?.navigator?.geolocation) {
      navigator?.permissions.query({ name: 'geolocation' })
        .then((PermissionStatus: any) => {

          if (PermissionStatus.state == 'granted') {
            permission = 'granted';
          } else if (PermissionStatus.state == 'prompt') {
            permission = 'not-granted';
          } else {
            permission = 'denied';
          }

          if (permission === 'not-granted') {
            this.isfirstTime = true;
            this.setupCountryWithLocation();
          } else {
            this.setupCountryWithTenant(Number(tenantId));
          }
        },
          (error: any) => {

          });
    }
  }

  setupCountryWithTenant(tenantId: number) {
    let country = this.countries.find(
      (x: any) => x.tenantId === tenantId
    );
    if (!country) {
      country = this.countries[0];
    }
    country.selected = true;
    if (this.selectedTenant != tenantId) {
      this.selectedTenant = country.tenantId;
      localStorage.setItem('tenantId', country.tenantId);
      localStorage.setItem('allCountryTenants', JSON.stringify(this.countries));

      location.reload();
    } else {
      this.selectedTenant = country.tenantId;
      this.selectedTenant = country.tenantId;
      localStorage.setItem('tenantId', country.tenantId);
    }
    this.cd.detectChanges();
  }

  setupCountryWithLocation() {
    if (window?.navigator?.geolocation) {
      this.loaderService.show();
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          if ('geolocation' in navigator) {
            this.loaderService.show();
            navigator.geolocation.getCurrentPosition(
              (position) => {
                this.Lat = position.coords.latitude;
                this.Lng = position.coords.longitude;
                this.zoom = 8;
                this.permission = true;


                let latlng = new google.maps.LatLng(this.Lat, this.Lng);
                this.geoCoder.geocode({ 'latLng': latlng }, (results: any, status: any) => {
                  if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0]) {


                      let isoCountry = 'UG';
                      results[0].address_components.forEach((obj: any) => {
                        if (obj.types.includes('country')) isoCountry = obj.short_name;
                      });

                      let country = this.countries.find(
                        (x: any) => x.isoCode === isoCountry
                      );
                      this.loaderService.hide();
                      this.setupCountryWithTenant(country.tenantId ?? 0);
                    }
                  }
                });
              },
              (error: any) => {

              }, {
              maximumAge: 60000,
              timeout: 2000
            }
            );
          }
        },
        (error) => {
          const tenantId = localStorage.getItem('tenantId') || environment.defaultTenant;
          this.setupCountryWithTenant(Number(tenantId));
        }
      );
    }
  }

  getAllCart(): void {
    const cartData = {
      cartId: window.localStorage.getItem('cartId'),
      sessionId: window.localStorage.getItem('sessionId') || ''
    };
    if (cartData.sessionId) {
      this.cartService.getCart(cartData.sessionId)
        .subscribe({
          next: (res: any) => {
            this.cartListCount = 0;
            this.cartListData = [];
            if (res.data?.records?.length) {
              this.cartListCount = 0;
              if (res.data.records[0].cartDetails.length) {
                this.cartListCount = res.data.records[0].cartDetails.length;
                this.cartListData = res.data.records[0].cartDetails;

              }
              if (res.data.records[0].cartDetailsDPay && res.data.records[0].cartDetailsDPay.length) {
                this.cartListCount += res.data.records[0].cartDetailsDPay.length;
                this.cartListData = this.cartListData.concat(res.data.records[0].cartDetailsDPay)
              }
              this.mainDataService.setCartLenghtData(this.cartListCount);
              this.mainDataService.setCartItemsData(this.cartListData);

            } else {
              this.mainDataService.setCartLenghtData(0);
              this.mainDataService.setCartItemsData([]);
            }
          }
        });
    } else {
      this.products = [];
    }

  }

  public compareCartProducts(products: [], storeProducts: []) {
    if (products.length) {

      products.forEach((item: any) => {
        storeProducts.forEach((data: any) => {
          if (item.specsProductId === data.specsProductId) {
            this.products.push(item);


          }
        });
      });
    } else {
      this.products = storeProducts;
    }

    localStorage.setItem('addedProducts', JSON.stringify(this.products));
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.getAllCart();


      this.authTokenService.authTokenData.subscribe(
        (message) => (this.authToken = message)
      );
      if (!this.authToken) {
        this.authToken = this.cookieService.get('authToken');
      }


      this.subscription[2] = this.store.subscription('cartProducts').subscribe({
        next: (res: any) => {
          if (res) {
            this.products = res;
            this.cd.detectChanges();

          }

        },
        error: (err: any) => {
          console.error(err);
        },
      });


      this.subscription[4] = this.store.subscription('mainData').subscribe({
        next: (res: any) => {
          let data = res?.find((obj: any) => obj.key.toLowerCase() === 'logo');
          if (data) this.logo = '/' + (data.displayName || this.logo);
        },
        error: (err: any) => {
          console.error(err);
        },
      });
    }, 1);
  }

  ngOnDestroy(): void {
    this.subscription.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  resetStorage() {


    localStorage.removeItem('decimalValue');
    localStorage.removeItem('countryPhone');
    localStorage.removeItem('PhoneLength');
    localStorage.removeItem('currency');
    localStorage.removeItem('customerAddressLandmarkRequired');
    window.location.reload();
  }

  async logOut(): Promise<void> {
    this.authTokenService.callLogout().subscribe({
      next: (res: any) => {},
      error: (err)=> {}
    });
    // await this.router.navigate(['/']);
    const tenantId = localStorage.getItem('tenantId') ?? environment.defaultTenant;
    this.authToken = null;

    sessionStorage.clear();
    this.authTokenService.authTokenSet('');


    this.cookieService.delete('authToken', '/');
    this.store.set('profile', '');
    this.mainDataService.setCartLenghtData(null);
    this.mainDataService.setUserData(null);
    localStorage.clear();

    this.router.navigateByUrl('/');

    localStorage.setItem('sessionId', '');
    localStorage.setItem('addedProducts', '');
    localStorage.setItem('cartId', '');
    this.store.set('cartProducts', []);
    // this.router.navigate(['/'])
    //   .then(() => {
    //     window.location.reload();
    //   });

    localStorage.setItem('tenantId', tenantId);
  }

  getLanguages() {
    this.languageService.getLanguage().subscribe((res) => {

      if (res?.languages) {
        let storedLang = localStorage.getItem('language');
        if (storedLang) {
          // this.selectedLanguage = localStorage.getItem('lang')?localStorage.getItem('lang'):'';
          //  this.selectedLanguage = storedLang;
        } else {
          let defaultLanguage = res.languages.find((x) => x.isDefault);
          if (!defaultLanguage && res.languages.length > 0) {
            this.defaultLanguage = res.languages[0];
          }
          if (defaultLanguage) {
            this.selectedLanguage = localStorage.getItem('lang') ? localStorage.getItem('lang') : '';
            // this.selectedLanguage = defaultLanguage.code;
          }
        }
        this.languages = res.languages;
      }

    });
  }

  changeLang(lang: any): void {
    localStorage.setItem('language', lang);
    this.translate.use(lang);
  }


  setTenant(tenantId: any) {
    const tenantIdValue = localStorage.getItem('tenantId');
    if (tenantIdValue !== tenantId) {
      // this.router.navigateByUrl('/');
      this.logOut();
      this.tenantService.setTenant(tenantId);
      // await this.router.navigate(['/']);
      this.router.navigate(['/'])
        .then(() => {
          window.location.reload();
        });
      // location.reload();
    } else {
      this.showDialog = false;
    }

  }
}
